import { useState, useEffect } from 'react';
import { throttle } from 'lodash';

const handlers = new Set();

function onScroll() {
    handlers.forEach(fn => fn());
}

export default function useScroll(options = {}) {
    const { wait = 100 } = options;
    const [scrollTop, setScrollTop] = useState(0);

    const handleScroll = throttle(() => {
        setScrollTop(document.documentElement.scrollTop || document.body.scrollTop);
    }, wait);

    useEffect(() => {
        if (handlers.size === 0) {
            window.addEventListener('scroll', onScroll);
        }

        handlers.add(handleScroll);

        return () => {
            handlers.delete(handleScroll);

            if (handlers.size === 0) {
                window.removeEventListener('scroll', onScroll);
            }
        };
    }, []);

    return scrollTop;
}
